import axios from "axios";
import { API_URL } from "constants";

// The one place that knows this URL; older callers still build it themselves.
export const fetchFileTemplates = async (companyId) => {
  const url = `${API_URL}/${companyId}/files/templates/fetch-file-templates`;
  return axios.get(url).then((response) => response.data);
};
